import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SessionStorageService {
  
  constructor() { }

  public setItem(key: string, value: string) {
    sessionStorage.setItem(key, value);
  }
    
  public getItem(key: string){ 
    return sessionStorage.getItem(key)
  }
  public removeItem(key:string) {
    sessionStorage.removeItem(key);
  }
  public clear(){
    const userClaimsKey = "userClaims";
    const userClaimsValue = this.getItem(userClaimsKey);

    sessionStorage.clear(); 
    sessionStorage.setItem('pinLoaded', 'true');

    if (userClaimsValue) {
      this.setItem(userClaimsKey, userClaimsValue);
    }
  }
}